import React, { useState } from 'react';
import { FaRobot, FaTelegramPlane, FaGlobe, FaEnvelope, FaCheck, FaRocket } from 'react-icons/fa';
import { BiBot } from 'react-icons/bi';
import '../styles/BotRequestForm.css';

const BotRequestForm = () => {
  const [formData, setFormData] = useState({
    projectName: '',
    telegramAccount: '',
    website: '',
    email: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.projectName.trim()) {
      errors.projectName = 'Project name is required';
    }

    if (!formData.telegramAccount.trim()) {
      errors.telegramAccount = 'Telegram account is required';
    } else if (!formData.telegramAccount.startsWith('@')) {
      errors.telegramAccount = 'Telegram account should start with @';
    }

    if (!formData.website.trim()) {
      errors.website = 'Website is required';
    }

    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!formData.email.includes('@')) {
      errors.email = 'Please enter a valid email';
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const response = await fetch('https://api.brevo.com/v3/smtp/email', {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'api-key': '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',
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          sender: {
            name: "The Firm Bot Request",
            email: "support@taptaparabia.com"
          },
          to: [{
            email: "amer.sarhan@gmail.com",
            name: "Amer Sarhan"
          }],
          subject: `New Bot Request from ${formData.projectName}`,
          htmlContent: `
            <h2>New Bot Request</h2>
            <p><strong>Project Name:</strong> ${formData.projectName}</p>
            <p><strong>Telegram Account:</strong> ${formData.telegramAccount}</p>
            <p><strong>Website:</strong> ${formData.website}</p>
            <p><strong>Email:</strong> ${formData.email}</p>
          `
        })
      });

      const data = await response.json();

      if (response.ok) {
        setMessage({
          type: 'success',
          text: 'Your request has been submitted successfully! We will contact you soon.'
        });
        setFormData({
          projectName: '',
          telegramAccount: '',
          website: '',
          email: ''
        });
        setFormErrors({});
      } else {
        throw new Error(data.message || 'Failed to submit form');
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage({
        type: 'error',
        text: 'Failed to submit form. Please try again later or contact us directly on Telegram.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bot-request-container">
      <div className="floating-shapes">
        <div className="shape shape-1"><BiBot /></div>
        <div className="shape shape-2"><FaRobot /></div>
        <div className="shape shape-3"><BiBot /></div>
        <div className="shape shape-4"><FaRobot /></div>
      </div>

      <div className="bot-request-content">
        <div className="form-header">
          <div className="icon-container">
            <FaRobot className="header-icon" />
          </div>
          <h1>Request a Custom AI Bot</h1>
          <p>Let our expert team develop a powerful AI bot tailored to your project's needs</p>
        </div>

        <div className="features-grid">
          <div className="feature-item">
            <FaCheck className="feature-icon" />
            <span>Custom Development</span>
          </div>
          <div className="feature-item">
            <FaCheck className="feature-icon" />
            <span>AI Integration</span>
          </div>
          <div className="feature-item">
            <FaCheck className="feature-icon" />
            <span>24/7 Support</span>
          </div>
          <div className="feature-item">
            <FaCheck className="feature-icon" />
            <span>Scalable Solution</span>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} className="bot-request-form">
          <div className="form-group">
            <label htmlFor="projectName">
              <FaRocket className="input-icon" />
              Project Name *
            </label>
            <input
              type="text"
              id="projectName"
              name="projectName"
              value={formData.projectName}
              onChange={handleChange}
              required
              placeholder="Enter your project name"
              className={formErrors.projectName ? 'error' : ''}
            />
            {formErrors.projectName && <div className="error-message">{formErrors.projectName}</div>}
          </div>

          <div className="form-group">
            <label htmlFor="telegramAccount">
              <FaTelegramPlane className="input-icon" />
              Telegram Account *
            </label>
            <input
              type="text"
              id="telegramAccount"
              name="telegramAccount"
              value={formData.telegramAccount}
              onChange={handleChange}
              required
              placeholder="@yourtelegramaccount"
              className={formErrors.telegramAccount ? 'error' : ''}
            />
            {formErrors.telegramAccount && <div className="error-message">{formErrors.telegramAccount}</div>}
          </div>

          <div className="form-group">
            <label htmlFor="website">
              <FaGlobe className="input-icon" />
              Project Website
            </label>
            <input
              type="text"
              id="website"
              name="website"
              value={formData.website}
              onChange={handleChange}
              placeholder="yourproject.com"
              className={formErrors.website ? 'error' : ''}
            />
            {formErrors.website && <div className="error-message">{formErrors.website}</div>}
          </div>

          <div className="form-group">
            <label htmlFor="email">
              <FaEnvelope className="input-icon" />
              Contact Email *
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your@email.com"
              className={formErrors.email ? 'error' : ''}
            />
            {formErrors.email && <div className="error-message">{formErrors.email}</div>}
          </div>

          <button type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner"></span>
                <span>Submitting...</span>
              </>
            ) : (
              <>
                <FaRocket className="button-icon" />
                <span>Submit Request</span>
              </>
            )}
          </button>

          {message && (
            <div className={`message ${message.type === 'success' ? 'success' : 'error'}`}>
              {message.text}
            </div>
          )}
        </form>

        <div className="form-footer">
          <h3>Why Choose Our Bot Development?</h3>
          <div className="benefits-list">
            <div className="benefit-item">
              <div className="benefit-icon">🤖</div>
              <div className="benefit-text">
                <h4>Advanced AI Integration</h4>
                <p>Powered by cutting-edge AI technology</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">⚡</div>
              <div className="benefit-text">
                <h4>Fast Development</h4>
                <p>Quick turnaround with expert team</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🛡️</div>
              <div className="benefit-text">
                <h4>Secure & Reliable</h4>
                <p>Built with security best practices</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BotRequestForm; 